import { render } from "./radio-group.vue?vue&type=template&id=7834d887&ts=true"
import script from "./radio-group.vue?vue&type=script&lang=ts"
export * from "./radio-group.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__